import {getMydockets,getUniqueCaseid} from "../services/http-services/HttpServices";
import { SET_DOCKET_DATA,SET_DOCKET_STATUS } from "../config";
// import { validateForm } from "../services/helper/Form1Helper";
import { history } from "../services/helper/Helper";
import { showLoader,hideLoader, notification,refreshNativeDataTable } from "./uiAction";


function setDocketData(data) {
	return {
    type: SET_DOCKET_DATA,
    docketList:data
  }
}

function setDocketStatus(data) {
	// data = (data!=='Closed') ? 'open' : 'Closed';
	return {
		type: SET_DOCKET_STATUS,
		status:data
	}
}

/* Name : Neha 
   Description : Function is used to fetch the dockets and set to dashboard page
 */
export function fetchDocketData() {
  return function(dispatch) {	
		dispatch(
			 refreshNativeDataTable(document.querySelector('.table-button-menu-item[aria-label="refresh"]'))
		 )
  }
 
}
/* 
	Name : Neha Agrawal
	Description : Function is used to fetch the docket based on the unique number.
*/
export function findDockets(data) {
  return function(dispatch) {
     if(data.unique_code==='' || data.unique_code.length !== 8){
       dispatch(notification("Please enter the unique 8 digit code found on your Notice of Hearing from Tax Court."));
	   // setTimeout(()=>dispatch(notification),0)  
	 }else{
		 dispatch(showLoader())
		 return getUniqueCaseid(data)
			.then(json=>{
				dispatch(hideLoader())
				if(json.flag==='false')
				{
					dispatch(notification("We're unable to provide access to the case information. Please contact judge assistant on your Notice of Hearing."));
					// setTimeout(()=>dispatch(notification),0)  
					
				}else{
					dispatch(showLoader())
					dispatch(setDocketStatus(json.status))
					let docketStatus = (json.status!=='Closed') ? 'open' : 'Closed';
					history.push('/publicAccess/dashboard/'+docketStatus);
					dispatch(hideLoader())
					setTimeout(()=> dispatch(
						refreshNativeDataTable(document.querySelector('.table-button-menu-item[aria-label="refresh"]'))
					), 100);
				}
				  
			})
		}
     
     }
  }